import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18NextHttpBackend from "i18next-http-backend";

// 国际化多语言支持
// 语言文件保存在 src/locales/{语言}/translation.json

export type SupportLanguage = "zh-CN" | "zh-TW" | "en" | "ja";

// 从LocalStorage获取默认语言
const getDefaultLanguage = (): SupportLanguage => {
  const savedLanguage = localStorage.getItem("Language");
  if (savedLanguage && ["zh-CN", "zh-TW", "en", "ja"].includes(savedLanguage)) {
    return savedLanguage as SupportLanguage;
  }
  return "zh-CN"; // 如果没有保存的语言设置或语言设置无效，默认使用简体中文
};

i18n
  .use(I18NextHttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: "zh-CN",
    lng: getDefaultLanguage(), // 设置当前语言
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
